import { useEffect } from 'react';

/**
 * Pulls a page index back into range after the list behind it shrinks.
 *
 * The awards-service lists fix pageSize server-side, so when a status change or
 * filter drops the total below the current page's first row, that page returns
 * empty and the table dead-ends on "nothing here" with the stepper gone. This
 * clamps the page state back to the last real page so the next fetch lands on
 * data instead.
 *
 * Guards on totalPages, never totalCount directly, so it stays correct at any
 * pageSize. A total of 0 clamps to page 1 (never page 0).
 *
 * @param {number} page - Current 1-based page.
 * @param {number} totalCount - Total rows the list currently reports.
 * @param {number} pageSize - Rows per page.
 * @param {(page: number) => void} setPage - Setter for the page state.
 */
const useClampedPage = (page, totalCount, pageSize, setPage) => {
  const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));

  useEffect(() => {
    if (page > totalPages) setPage(totalPages);
  }, [page, totalPages, setPage]);
};

export default useClampedPage;
